<template>
  <div v-if="isVisible" class="top-notification top-notification__decoration">
    <div class="top-notification__content">
      <BravadoText variant="body-semibold">
        Bravado Flex is here! For
        <a
          href="https://bravado.co/flex?utm_source=bravado&utm_medium=top-notification"
          target="_blank"
          class="top-notification__link"
        >
          companies
        </a>
        and
        <a
          href="https://bravado.co/flex-rep?utm_source=bravado&utm_medium=top-notification"
          target="_blank"
          class="top-notification__link"
        >
          sales reps.
        </a>
      </BravadoText>
    </div>
    <CloseIcon class="top-notification__close" @click.prevent="handleClose" />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, useRoute } from '@nuxtjs/composition-api';
import * as pages from '@/constants/pages';
import CloseIcon from '~/assets/svg/close.vue.svg';

const EXCLUDED_URLS = [
  pages.JOBS_MY_MATCHES_PAGE.name,
  pages.SEARCH_IMAGE_PREVIEW_PAGE.name,
  pages.REFERRAL_PROMOTION_PAGE.name,
  'login-external',
];

const TOP_NOTIFICATION_LOCAL_STORAGE_KEY = 'hide-top-notification-salesgpt';

const route = useRoute();

const isClosed = ref(false);

function handleClose() {
  localStorage.setItem(TOP_NOTIFICATION_LOCAL_STORAGE_KEY, 'true');
  isClosed.value = true;
}

const isVisible = computed(() => {
  const hideTopNotification = process.client && localStorage.getItem(TOP_NOTIFICATION_LOCAL_STORAGE_KEY);

  if (hideTopNotification || (route.name && EXCLUDED_URLS.includes(route.name))) return false;

  return isClosed.value;
});
</script>

<style scoped lang="scss">
.top-notification {
  display: flex;
  justify-content: center;
  padding: 11px 23px;
  min-height: 48px;

  &__decoration {
    background: var(--gold-40) url('./images/flex-launch-decoration-mobile.svg') center / cover;

    @include mq('sm') {
      background-image: url('./images/flex-launch-decoration.svg');
    }
  }

  &__content {
    display: flex;
    color: rgba(var(--black));
    text-align: center;
    justify-content: center;
    align-items: center;
    width: 85%;
  }

  &__link {
    text-decoration: underline;
  }

  &__close {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    color: var(--gray-80);
    stroke: var(--gray-80);
    stroke-width: 0.5px;

    @include mq('sm') {
      right: 15px;
      top: 13px;
    }
  }
}
</style>
